import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationQuery } from '../state/authentication.query';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuardService implements CanActivate {

  constructor(
    private authQuery: AuthenticationQuery,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isLoggedIn = this.authQuery.isUserLoggedIn;
    const isMfaVerified = this.authQuery.getValue().mfaVerified;

    if (!isLoggedIn) {
      this.router.navigate(['/login'], {
        queryParams: { returnUrl: state.url }
      });
      return false;
    }

    const mfaDoneAlready = sessionStorage.getItem('mfaDone') === 'true';

    if (!isMfaVerified && !mfaDoneAlready) {
      this.router.navigate(['/authentication/login'], {
        queryParams: { returnUrl: state.url }
      });
      return false;

    }


    if (isMfaVerified && !mfaDoneAlready) {
      sessionStorage.setItem('mfaDone', 'true');
    }

    return true;
  }
}
